import { render, staticRenderFns } from "./registrationForm.vue?vue&type=template&id=22b9dfe6&scoped=true&"
import script from "./registrationForm.vue?vue&type=script&lang=js&"
export * from "./registrationForm.vue?vue&type=script&lang=js&"
import style0 from "./registrationForm.vue?vue&type=style&index=0&id=22b9dfe6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9dfe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b9dfe6')) {
      api.createRecord('22b9dfe6', component.options)
    } else {
      api.reload('22b9dfe6', component.options)
    }
    module.hot.accept("./registrationForm.vue?vue&type=template&id=22b9dfe6&scoped=true&", function () {
      api.rerender('22b9dfe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/registrationForm.vue"
export default component.exports